import React from "react";
import styled from "styled-components";
import { Reorder } from "framer-motion";
import { DragOutlined } from "@ant-design/icons";
import MemberDropdown from "./MemberDropdown";
import RemoveButtonGroup from "./RemoveButtonGroup";

const DraggableItemWrapper = styled(Reorder.Item)`
  display: flex;
  align-items: center;
  user-select: none;
  padding: 0 8px;
  margin: 0 8px 0 0;
  position: relative;
  display: inline-flex;
  touch-action: none;
`;

const DraggableItem = ({
  member,
  availableMembers,
  intl,
  updateMethods,
  onDragEnd,
}) => {
  return (
    <DraggableItemWrapper
      key={member.name}
      value={member}
      onDragEnd={() => onDragEnd(member)}
    >
      <DragOutlined />
      <RemoveButtonGroup onRemoveClick={() => updateMethods.remove(member)}>
        <MemberDropdown
          availableMembers={availableMembers}
          onClick={(updateWith) => updateMethods.update(member, updateWith)}
          intl={intl}
        >
          {intl.formatMessage({
            id: `app.analytics.${member.name}`,
            defaultMessage: member.shortTitle,
          })}
        </MemberDropdown>
      </RemoveButtonGroup>
    </DraggableItemWrapper>
  );
};

export default DraggableItem;
